import {
  ORDERS_LOAD_REQUEST,
  ORDERS_LOAD_SUCCESS,
  ORDERS_LOAD_FAILURE
} from '../types/orders-types';

const initialState = {
  loading: false,
  success: false,
  orders: []
};

function orders(state = initialState, action: any = null) {
  switch (action.type) {
    case ORDERS_LOAD_REQUEST:
      return {
        ...state,
        success: false,
        loading: true
      };

    case ORDERS_LOAD_FAILURE:
      return {
        ...state,
        success: false,
        loading: false
      };

    case ORDERS_LOAD_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        success: true,
        loading: false
      };

    default:
      return state;
  }
}

export default orders;
